/**
 * Requisiti password Cognito (replicano la policy del pool mobile).
 * Vedi src/screens/login/v2/ResetPasswordScreen.js (mobile) per allineamento.
 */

export type PasswordRule = {
  id: 'length' | 'lowercase' | 'uppercase' | 'digit'
  label: string
  test: (pwd: string) => boolean
}

export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: 'length',
    label: 'Almeno 8 caratteri',
    test: (p) => p.length >= 8,
  },
  {
    id: 'lowercase',
    label: 'Una lettera minuscola',
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: 'uppercase',
    label: 'Una lettera maiuscola',
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: 'digit',
    label: 'Un numero',
    test: (p) => /\d/.test(p),
  },
]

export function isPasswordValid(pwd: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(pwd))
}

export function evaluatePassword(pwd: string) {
  return PASSWORD_RULES.map((rule) => ({
    ...rule,
    valid: rule.test(pwd),
  }))
}
